import { DateTime } from 'luxon';
import type { ICountry } from './Country';
import type Country from './Country';

export interface FulfillmentCenterJson {
    id?: number;
    created_at: string;
    updated_at: string;
    name: string;
    marketplace_id?: number;
    country?: ICountry;
    country_id?: number;
}

export default class FulfillmentCenter {
    id?: number;
    created_at: DateTime = DateTime.now();
    updated_at: DateTime = DateTime.now();
    name = '';
    marketplace_id?: number;
    country_id?: number;
    country?: Country = undefined;

    toJSON(): FulfillmentCenterJson {
        //console.debug("FulfillmentCenter.toJSON()", this);
        return Object.assign({} as FulfillmentCenterJson, this, {
            created_at: undefined,
            updated_at: undefined,
        });
    }

    static fromJSON(json: FulfillmentCenterJson): FulfillmentCenter {
        //console.debug("FulfillmentCenter.fromJSON()", json);
        const fulfillmentCenter = Object.create(FulfillmentCenter.prototype);
        return Object.assign(fulfillmentCenter, json, {
            created_at: json.created_at ? DateTime.fromISO(json.created_at) : DateTime.now(),
            updated_at: json.updated_at ? DateTime.fromISO(json.updated_at) : DateTime.now(),
        });
    }
}
